import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import Layout from '../components/layout';
import About from '../templates/about';
import Nearby from '../templates/nearby';
import Contacts from '../templates/contacts';
import SEO from '../components/seo';
import Header from '../components/header';
import Tour from '../components/tour';

const AboutPage = ({
  data: {
    allContentfulAbout: { edges: about },
    allContentfulContacts: { edges: rawContacts },
    allContentfulAttractions: { edges: attractions },
  },
  location,
}) => {
  const contacts = {};
  // eslint-disable-next-line no-return-assign
  rawContacts.forEach(({ node: { type, value } }) => (contacts[type] = value));
  return (
    <Layout>
      <SEO
        lang="ru"
        title="О Нас"
        keywords={[
          'о нас',
          'описание отеля',
          'описание гостевого дома',
          'ориентиры поблизости',
          'контакты',
          'отель',
          'гостевой',
          'дом',
          'hotel',
          'guest',
          'house',
          'dom',
          'yalta',
          'гостевой дом',
          'guest house',
          'dom_yalta',
          'аренда жилья в ялте 2019',
          'отдых в ялте 2019',
          'семейный отдых',
        ]}
      />
      <Helmet>
        <link rel="preload" href="/tour/parking.jpeg" as="image" />
        <link rel="preload" href="/tour/first_floor.jpeg" as="image" />
        <link rel="preload" href="/tour/second_floor.jpeg" as="image" />
        <link rel="preload" href="/tour/room_3.jpeg" as="image" />
        <link rel="preload" href="/tour/room_4.jpeg" as="image" />
        <link rel="preload" href="/tour/room_5.jpeg" as="image" />
        <link rel="preload" href="/tour/room_6.jpeg" as="image" />
        <link rel="preload" href="/tour/room_7.jpeg" as="image" />
        <link rel="preload" href="/tour/room_8.jpeg" as="image" />
        <link rel="preload" href="/tour/pool.jpeg" as="image" />
        <link rel="preload" href="/tour/lounge.jpeg" as="image" />
        <link rel="preload" href="/tour/terrace.jpeg" as="image" />
      </Helmet>
      <Header contacts={contacts} location={location} sticky />
      <main className="main">
        <div className="pagecontent">
          <div className="container">
            <Tour />
            <section className="section direct">
              <div id="yandex_rtb_R-A-599273-1"></div>
              <script
                id="gatsby-plugin-yandex-direct"
                key={`gatsby-plugin-yandex-direct`}
                dangerouslySetInnerHTML={{
                  __html: `(function(w, d, n, s, t) {
                      w[n] = w[n] || [];
                      w[n].push(function() {
                        Ya.Context.AdvManager.render({
                          blockId: "R-A-599273-1",
                          renderTo: "yandex_rtb_R-A-599273-1",
                          async: true
                        });
                      });
                      t = d.getElementsByTagName("script")[0];
                      s = d.createElement("script");
                      s.type = "text/javascript";
                      s.src = "//an.yandex.ru/system/context.js";
                      s.async = true;
                      t.parentNode.insertBefore(s, t);
                    })(this, this.document, "yandexContextAsyncCallbacks");`
                }}
              />
            </section>
            <About items={about} />
            <Nearby items={attractions} />
          </div>
        </div>
        <Contacts contacts={contacts} />
      </main>
    </Layout>
  );
};

export const query = graphql`
  query {
    allContentfulContacts {
      edges {
        node {
          id
          type
          value
        }
      }
    }
    allContentfulAbout(sort: { fields: [order], order: ASC }) {
      edges {
        node {
          id
          title
          description {
            json
          }
          photo {
            file {
              url
            }
            fixed(width: 485, resizingBehavior: SCALE) {
              ...GatsbyContentfulFixed_tracedSVG
            }
          }
        }
      }
    }
    allContentfulAttractions(sort: { fields: [order], order: ASC }) {
      edges {
        node {
          id
          title
          icon
          places {
            id
            title
            distance
          }
        }
      }
    }
  }
`;

AboutPage.propTypes = {
  data: PropTypes.shape({
    allContentfulAbout: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
    allContentfulContacts: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
  }).isRequired,
};

export default AboutPage;
